import {cacheResource, getCacheResponse} from './cache-utils';

/**
 * @param {string} cacheName
 * @param {string} resourceUrl
 * @returns {Promise<string>}
 */
export async function getBlobFromUrl (cacheName, resourceUrl) {
	let response = await getCacheResponse(cacheName, resourceUrl);
	if (!response) {
		response = await cacheResource(cacheName, resourceUrl);
	}
	return getBlobUrlFromResponse(response);
}
/**
 *
 * @param {Response} response
 * @returns {Promise<string>}
 */
async function getBlobUrlFromResponse (response) {
	const blob = await response.blob();
	const blobUrl = URL.createObjectURL(blob);
	return blobUrl;
}
